
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prototypowanie-elektroniki-i-pcb",
      function () {
        return require("private-next-pages/prototypowanie-elektroniki-i-pcb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prototypowanie-elektroniki-i-pcb"])
      });
    }
  